export default __webpack_public_path__ + "static/media/imgBlog.e77fbe02.png";